import axios from 'axios';
import { AuthService } from './auth.service';
import { ENDPOINTS } from '../constants/endpoints';
import { IComputeSettlementRequest, IFinalSettlement } from '../interfaces/payroll.interface';

// Final settlement lifecycle (spec §2.5). Every id-addressed route carries institutionId as a
// query param (§2.0 tenancy assert pairing) — mirrors LeaveEncashmentService/EmployeeExitService.
export const FinalSettlementService = {
    compute: async (
        institutionId: string,
        exitId: string,
        request: IComputeSettlementRequest
    ): Promise<IFinalSettlement> => {
        const response = await axios.post(
            ENDPOINTS.FINAL_SETTLEMENT.COMPUTE(institutionId, exitId),
            request,
            { headers: AuthService.getAuthHeader() }
        );
        return response.data;
    },

    finalize: async (id: string, institutionId: string): Promise<IFinalSettlement> => {
        const response = await axios.post(
            ENDPOINTS.FINAL_SETTLEMENT.FINALIZE(id, institutionId),
            {},
            { headers: AuthService.getAuthHeader() }
        );
        return response.data;
    },

    unfinalize: async (id: string, institutionId: string): Promise<IFinalSettlement> => {
        const response = await axios.post(
            ENDPOINTS.FINAL_SETTLEMENT.UNFINALIZE(id, institutionId),
            {},
            { headers: AuthService.getAuthHeader() }
        );
        return response.data;
    },

    pay: async (id: string, institutionId: string): Promise<IFinalSettlement> => {
        const response = await axios.post(
            ENDPOINTS.FINAL_SETTLEMENT.PAY(id, institutionId),
            {},
            { headers: AuthService.getAuthHeader() }
        );
        return response.data;
    },

    voidSettlement: async (id: string, institutionId: string): Promise<IFinalSettlement> => {
        const response = await axios.post(
            ENDPOINTS.FINAL_SETTLEMENT.VOID(id, institutionId),
            {},
            { headers: AuthService.getAuthHeader() }
        );
        return response.data;
    },

    list: async (institutionId: string): Promise<IFinalSettlement[]> => {
        const response = await axios.get(ENDPOINTS.FINAL_SETTLEMENT.LIST(institutionId), {
            headers: AuthService.getAuthHeader(),
        });
        return response.data;
    },

    detail: async (id: string, institutionId: string): Promise<IFinalSettlement> => {
        const response = await axios.get(ENDPOINTS.FINAL_SETTLEMENT.BY_ID(id, institutionId), {
            headers: AuthService.getAuthHeader(),
        });
        return response.data;
    },

    delete: async (id: string, institutionId: string): Promise<void> => {
        await axios.delete(ENDPOINTS.FINAL_SETTLEMENT.BY_ID(id, institutionId), {
            headers: AuthService.getAuthHeader(),
        });
    },
};
